export default "__VITE_ASSET__DgKDxTyg__"